import cleanedFilename from '~/util/cleanedFilename';

export default {
  ERROR_MESSAGE: `${cleanedFilename(__filename)}-error-message`,
  LIST_ITEM: `${cleanedFilename(__filename)}-list-item`,
  HEADER_ROW: `${cleanedFilename(__filename)}-header-row`,
  CONTAINER: `${cleanedFilename(__filename)}-container`,
};
